/**
 * @param {Function} callback
 * @param {string} url
 * @param {FormData|null} formData
 * @param {string} method
 */
export default (callback, url, formData= null, method = 'GET') => {
  let httpRequest = new XMLHttpRequest()
  httpRequest.onreadystatechange = function () {
    if (this.readyState === this.DONE) {
      if (this.status === 200) {
        callback(this, false)
      } else {
        console.warn('AJAX Error')
        callback(this, true)
      }
    }
  }
  httpRequest.open(method, url)
  httpRequest.send(formData)
}
